import ContentSection from '../components/content-section'
import { TeamPermissionsForm } from './team-permissions-form'

export default function SettingsTeam() {
  return (
    <ContentSection
      title='Configurações do Time'
      desc='Gerencie as permissões e configurações da sua equipe.'
    >
      <TeamPermissionsForm />
    </ContentSection>
  )
}
